import React, { FC } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { VoidHandler, WithClassName } from 'common/types'
import { ParentShareComplaints } from 'components/block/TooltipShareComplaints/ParentShareComplaints'
import { Meatballs } from 'components/designSystem/Meatballs/Meatballs'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { PopOverWithPin } from 'components/designSystem/Tooltip/PopOverWithPin'
import { useTooltip } from 'hooks/useTooltip'

export const Desktop: FC<
  WithClassName & { profileId: number; onCallback?: VoidHandler }
> = ({ className, profileId, onCallback }) => {
  const name = `share-complaint-menu-${profileId}`

  const [tooltipState, _] = useTooltip(name)

  return (
    <Parent className={cx(className)} data-name="share-complaint-desktop">
      <Overlay className={cx(tooltipState && overlayActiveCss)} />
      <PopOverWithPin
        enabled={true}
        name={name}
        position="bottomLeft"
        renderContent={({ isOpen, toggleIsOpen }) => (
          <>
            {isOpen && (
              <>
                <ParentShareComplaints
                  profileId={profileId}
                  onCallback={onCallback}
                  onClose={toggleIsOpen}
                />
              </>
            )}
          </>
        )}
      >
        <Meatballs />
      </PopOverWithPin>
    </Parent>
  )
}

const Parent = styled.div`
  display: block;
  color: var(--foreground-default);

  @media screen and (max-width: ${breakpoints.mobile + 1}px) {
    display: none;
  }
`

const Overlay = styled.div`
  background-color: var(--background-opacity-scrim);
  position: fixed;
  inset: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease-in-out;
`

const overlayActiveCss = css`
  opacity: 1;
  pointer-events: auto;
`
